import { useState, useCallback, useEffect } from "react"

const useDragScrolling = ref => {
  const [dragStart, setDragStart] = useState(-1)
  const [scrollStart, setScrollStart] = useState(0)

  const startDrag = useCallback(
    clientX => {
      setDragStart(clientX)
      setScrollStart(ref.current.scrollLeft)
    },
    [ref]
  )

  const endDrag = useCallback(() => {
    setDragStart(-1)
  }, [])

  useEffect(() => {
    window.addEventListener("mouseup", endDrag)

    return () => {
      window.removeEventListener("mouseup", endDrag)
    }
  }, [endDrag])

  return {
    dragging: dragStart >= 0,
    dragEvents: {
      onMouseDown: e => {
        startDrag(e.clientX)
      },
      onMouseMove: e => {
        if (dragStart >= 0) {
          ref.current.scrollLeft = scrollStart - e.clientX + dragStart
        }
      },
      onMouseUp: endDrag,
    },
  }
}

export default useDragScrolling
